<template>
    <div class="stacked-bar-graph">
        <ul class="stacked-bar-list">
            <li v-for="(item, index) in props.data" :key="index">
                <div class="stacked-bar">
                    <!-- 최대 3개 -->
                    <div
                        class="stacked-bar-inner"
                        v-for="(segment, itemIndex) in item.SegmentList"
                        :key="itemIndex"
                        :style="{
                            height: (segment.NormalizedValue ?? 0) * 100 + '%',
                            backgroundColor: segment.Color ?? '',
                        }"
                    ></div>
                </div>
            </li>
        </ul>
        <ul class="weekday-list">
            <li v-for="(item, index) in props.data" :key="index">
                {{ item.Label }}
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import type { StackedBar } from '@common/openapi-client/openapi';

const props = defineProps<{
    data: StackedBar[];
}>();
</script>

<style scoped lang="scss">
.stacked-bar-list {
    height: 8.9rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    & + .stacked-bar-list {
        margin-top: 1.8rem;
    }

    li {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        .stacked-bar {
            width: 50%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;

            div {
                &.stacked-bar-inner {
                    border-bottom: 1px solid $primary-white;
                    box-sizing: border-box;

                    &:first-child {
                        border-radius: 0.1rem 0.1rem 0 0;
                    }

                    &:last-child {
                        border-bottom: 0;
                    }
                }
            }
        }
    }
}

.weekday-list {
    padding-top: 0.4rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    li {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        background-color: #fff;
        color: $grey-5;
        white-space: nowrap;
        font-size: 1rem;
    }
}
</style>
